import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useRecoilState } from "recoil";

import { apiGetPlatformOptions } from "../../../lib/api/platform";
import { apiNotifySubscribe } from "../../../lib/api/engage";
import { engageState } from "../../../atoms/platform";

import Agendas from "../../../components/Engage/Agendas";
import EngageSideBar from "../../../components/Layout/EngageSideBar";
import EngageMenuButton from "../../../components/Layout/EngageMenuButton";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
}

export default function EngageAgendas() {
  const isMounted = useMounted();
  const router = useRouter();
  const { client } = router.query;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [clientState, setClientState] = useRecoilState(engageState);
  const [notifyField, setNotifyField] = useState("");

  useEffect(() => {
    async function fetchClient() {
      const results = await apiGetPlatformOptions(client);
      if (results) {
        setClientState(results);
      }
    }
    if (client) {
      if (!clientState) {
        fetchClient();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  // Email Validation Function
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Handle Button Click
  async function handleNotifyMe() {
    if (!isValidEmail(notifyField)) {
      alert("Please enter a valid email address.");
      return;
    }

    // API call to register
    const result = await apiNotifySubscribe(client, notifyField);
    if (result) {
      alert(
        "Thank you for registering.  When an agenda is published you will receive notifications via email.",
      );
      setNotifyField("");
    } else {
      alert("Issue with subscribing this email address.");
      setNotifyField("");
    }
  }

  return (
    <div className="h-screen flex overflow-hidden bg-white default-scrollbar">
      {clientState && isMounted && (
        <EngageSideBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          path="agendas"
        />
      )}

      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <EngageMenuButton setSidebarOpen={setSidebarOpen} />

        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-6">
            <div className="px-4 sm:px-6 md:px-8 mb-2 xl:mb-4">
              <div className="pb-2 xl:pb-5 border-b border-gray-400 flex items-end justify-between">
                <h1 className="text-lg xl:text-2xl leading-6 font-medium text-gray-900 xl:pl-8">
                  Agendas
                </h1>
                <div className="flex items-center">
                  <input
                    value={notifyField}
                    placeholder="Email Address"
                    className="block w-[200px] mr-1 bg-white border border-black rounded-md py-1 2xl:py-2 px-3 text-sm lg:text-base"
                    onChange={(e) => {
                      setNotifyField(e.target.value);
                    }}
                  />
                  <button
                    className="text-xs lg:text-sm 2xl:text-base px-2.5 py-2 rounded-md bg-blue-800 text-white hover:bg-blue-600 transform duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800"
                    onClick={() => {
                      handleNotifyMe();
                    }}
                  >
                    Notify Me
                  </button>
                </div>
              </div>
            </div>
            <div className="max-w-7xl 2xl:max-w-7/8 mx-auto px-4 sm:px-6 md:px-8">
              {isMounted && <Agendas />}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
